import DomPurify from "isomorphic-dompurify";

import type { FaqItem } from "./Faq";

const { sanitize } = DomPurify;

export type SeoFaqStructuredData = {
  "@context": "https://schema.org";
  "@type": "FAQPage";
  mainEntity: {
    "@type": "Question";
    name: string;
    acceptedAnswer: {
      "@type": "Answer";
      text: string;
    };
  }[];
};

type FaqJsonLDProps = {
  faqList: FaqItem[];
};

export const FaqJsonLD: React.FC<FaqJsonLDProps> = ({ faqList }) => {
  if (!faqList.length) {
    return null;
  }

  const schema: SeoFaqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map(({ faqTitle, faqDetails }) => ({
      "@type": "Question",
      name: faqTitle,
      acceptedAnswer: {
        "@type": "Answer",
        text: sanitize(faqDetails, { ALLOWED_TAGS: [] }),
      },
    })),
  };

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
};
